export interface InstanceType {
    id: string;
    label: string;
}

export interface TypeGroup {
    label: string;
    options: InstanceType[];
}

export interface InstanceTypes {
    type_groups: TypeGroup[];
}

export const instanceTypes: InstanceTypes = {
    type_groups: [
        {
            label: "General Purpose",
            options: [
                {
                    id: "ml.t3.medium",
                    label: "ml.t3.medium",
                },
                {
                    id: "ml.t3.large",
                    label: "ml.t3.large",
                },
                {
                    id: "ml.t3.xlarge",
                    label: "ml.t3.xlarge",
                },
                {
                    id: "ml.t3.2xlarge",
                    label: "ml.t3.2xlarge",
                },
                {
                    id: "ml.t2.medium",
                    label: "ml.t2.medium",
                },
                {
                    id: "ml.t2.large",
                    label: "ml.t2.large",
                },
                {
                    id: "ml.t2.xlarge",
                    label: "ml.t2.xlarge",
                },
                {
                    id: "ml.t2.2xlarge",
                    label: "ml.t2.2xlarge",
                },
                {
                    id: "ml.m5.xlarge",
                    label: "ml.m5.xlarge",
                },
                {
                    id: "ml.m5.2xlarge",
                    label: "ml.m5.2xlarge",
                },
                {
                    id: "ml.m5.4xlarge",
                    label: "ml.m5.4xlarge",
                },
                {
                    id: "ml.m5.12xlarge",
                    label: "ml.m5.12xlarge",
                },
                {
                    id: "ml.m5.24xlarge",
                    label: "ml.m5.24xlarge",
                },
                {
                    id: "ml.m5d.large",
                    label: "ml.m5d.large",
                },
                {
                    id: "ml.m5d.xlarge",
                    label: "ml.m5d.xlarge",
                },
                {
                    id: "ml.m5d.2xlarge",
                    label: "ml.m5d.2xlarge",
                },
                {
                    id: "ml.m5d.4xlarge",
                    label: "ml.m5d.4xlarge",
                },
                {
                    id: "ml.m5d.8xlarge",
                    label: "ml.m5d.8xlarge",
                },
                {
                    id: "ml.m5d.12xlarge",
                    label: "ml.m5d.12xlarge",
                },
                {
                    id: "ml.m5d.16xlarge",
                    label: "ml.m5d.16xlarge",
                },
                {
                    id: "ml.m5d.24xlarge",
                    label: "ml.m5d.24xlarge",
                },
                {
                    id: "ml.m4.xlarge",
                    label: "ml.m4.xlarge",
                },
                {
                    id: "ml.m4.2xlarge",
                    label: "ml.m4.2xlarge",
                },
                {
                    id: "ml.m4.4xlarge",
                    label: "ml.m4.4xlarge",
                },
                {
                    id: "ml.m4.10xlarge",
                    label: "ml.m4.10xlarge",
                },
                {
                    id: "ml.m4.16xlarge",
                    label: "ml.m4.16xlarge",
                }
            ]
        },
        {
            label: "Compute Optimized",
            options: [
                {
                    id: "ml.c5.xlarge",
                    label: "ml.c5.xlarge",
                },
                {
                    id: "ml.c5.2xlarge",
                    label: "ml.c5.2xlarge",
                },
                {
                    id: "ml.c5.4xlarge",
                    label: "ml.c5.4xlarge",
                },
                {
                    id: "ml.c5.9xlarge",
                    label: "ml.c5.9xlarge",
                },
                {
                    id: "ml.c5.18xlarge",
                    label: "ml.c5.18xlarge",
                },
                {
                    id: "ml.c5d.xlarge",
                    label: "ml.c5d.xlarge",
                },
                {
                    id: "ml.c5d.2xlarge",
                    label: "ml.c5d.2xlarge",
                },
                {
                    id: "ml.c5d.4xlarge",
                    label: "ml.c5d.4xlarge",
                },
                {
                    id: "ml.c5d.9xlarge",
                    label: "ml.c5d.9xlarge",
                },
                {
                    id: "ml.c5d.18xlarge",
                    label: "ml.c5d.18xlarge",
                },
                {
                    id: "ml.c4.xlarge",
                    label: "ml.c4.xlarge",
                },
                {
                    id: "ml.c4.2xlarge",
                    label: "ml.c4.2xlarge",
                },
                {
                    id: "ml.c4.4xlarge",
                    label: "ml.c4.4xlarge",
                },
                {
                    id: "ml.c4.8xlarge",
                    label: "ml.c4.8xlarge",
                }
            ]
        },
        {
            label: "Memory Optimized",
            options: [
                {
                    id: "ml.r5.large",
                    label: "ml.r5.large",
                },
                {
                    id: "ml.r5.xlarge",
                    label: "ml.r5.xlarge",
                },
                {
                    id: "ml.r5.2xlarge",
                    label: "ml.r5.2xlarge",
                },
                {
                    id: "ml.r5.4xlarge",
                    label: "ml.r5.4xlarge",
                },
                {
                    id: "ml.r5.8xlarge",
                    label: "ml.r5.8xlarge",
                },
                {
                    id: "ml.r5.12xlarge",
                    label: "ml.r5.12xlarge",
                },
                {
                    id: "ml.r5.16xlarge",
                    label: "ml.r5.16xlarge",
                },
                {
                    id: "ml.r5.24xlarge",
                    label: "ml.r5.24xlarge",
                }
            ]
        },
        {
            label: "Accelerated Computing",
            options: [
                {
                    id: "ml.p3.2xlarge",
                    label: "ml.p3.2xlarge",
                },
                {
                    id: "ml.p3.8xlarge",
                    label: "ml.p3.8xlarge",
                },
                {
                    id: "ml.p3.16xlarge",
                    label: "ml.p3.16xlarge",
                },
                {
                    id: "ml.p3dn.24xlarge",
                    label: "ml.p3dn.24xlarge",
                },
                {
                    id: "ml.p2.xlarge",
                    label: "ml.p2.xlarge",
                },
                {
                    id: "ml.p2.8xlarge",
                    label: "ml.p2.8xlarge",
                },
                {
                    id: "ml.p2.16xlarge",
                    label: "ml.p2.16xlarge",
                },
                {
                    id: "ml.g4dn.xlarge",
                    label: "ml.g4dn.xlarge",
                },
                {
                    id: "ml.g4dn.2xlarge",
                    label: "ml.g4dn.2xlarge",
                },
                {
                    id: "ml.g4dn.4xlarge",
                    label: "ml.g4dn.4xlarge",
                },
                {
                    id: "ml.g4dn.8xlarge",
                    label: "ml.g4dn.8xlarge",
                },
                {
                    id: "ml.g4dn.12xlarge",
                    label: "ml.g4dn.12xlarge",
                },
                {
                    id: "ml.g4dn.16xlarge",
                    label: "ml.g4dn.16xlarge",
                }
            ]
        }
    ]
};
